import React from "react";
import PropTypes from "prop-types";
import {Card, CardContent, Grid} from "@mui/material";
import QuizList from "./QuizList";
import CatList from "./CatList";
import EmailList from "./EmailList";
import Index from "../../../components/Container";
import PassGate from "../../../components/Videos/PassGate";

function Admin({type, user}) {

  return (
    <Index title="Admin" spacing>
      <Grid item xs={12} md={7}>
        <Card>
          <CardContent>
            <QuizList type={type}/>
          </CardContent>
        </Card>
        {/*{type == "Admin+" && <Card>*/}
        {/*  <CardContent>*/}
        {/*    <CatList/>*/}
        {/*  </CardContent>*/}
        {/*</Card>}*/}
      </Grid>
      {type == "Admin+" && <>
        <Grid item xs={12} md={5}>
          <Card>
            <CardContent>
              <CatList/>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={5}></Grid>
      </>}
      {/*<Grid item xs={12} md={7}>*/}
      {/*  <Card>*/}
      {/*    <CardContent>*/}
      {/*      <EmailList/>*/}
      {/*    </CardContent>*/}
      {/*  </Card>*/}
      {/*</Grid>*/}

    </Index>
  )
}

Admin.propTypes = {
  type: PropTypes.string.isRequired,
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired
}

export default Admin;
